// third party imports
import PropTypes from 'prop-types';

// project-imports
import { useDispatch, useSelector } from 'store';
import { devConsolelog } from 'helpers/utilityFunctions';
import useStyles from './styles';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { FormHelperText } from '@mui/material';

const Dropdown = (props) => {
    const { dropdownData, id, name, value, onChange, multiSelect = false, sx = {}, helperText, error = false } = props || {};
    return (
        <FormControl error={error} fullWidth sx={sx}>
            <InputLabel>{name}</InputLabel>
            <Select {...props} name={id} id={id} label={name} value={multiSelect ? [] : value} onChange={onChange} multiple={multiSelect}>
                {dropdownData?.map((data) => (
                    <MenuItem disabled={data?.disabled || false} key={data?.value} value={data?.value}>
                        {data?.label}
                    </MenuItem>
                ))}
            </Select>
            {helperText && <FormHelperText error>{helperText}</FormHelperText>}
        </FormControl>
    );
};
export default Dropdown;

Dropdown.propTypes = {
    // dropdownData: PropTypes.array,
    // id: PropTypes.string,
    // name: PropTypes.string,
    // value: PropTypes.string,
    // onChange: PropTypes.func,
    // multiSelect: PropTypes.bool,
    // sx: PropTypes.object
};
